import React from 'react';
import Header from '../header/Header';

const ProtectedLayout = ({ user, onLogout, children }) => {
  return (
    <>
      <Header user={user} onLogout={onLogout} />
      {children}
    </>
  );
};

export default ProtectedLayout;